/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StorefrontPlatformType } from './StorefrontPlatformType';
import {
    StorefrontPlatformTypeFromJSON,
    StorefrontPlatformTypeFromJSONTyped,
    StorefrontPlatformTypeToJSON,
    StorefrontPlatformTypeToJSONTyped,
} from './StorefrontPlatformType';
import type { StorefrontAddedBy } from './StorefrontAddedBy';
import {
    StorefrontAddedByFromJSON,
    StorefrontAddedByFromJSONTyped,
    StorefrontAddedByToJSON,
    StorefrontAddedByToJSONTyped,
} from './StorefrontAddedBy';

/**
 * Write-body shape for a storefront entry. Identical to `DropStorefront` minus `_id` (Mongo assigns subdocument ids) and minus `detectedFromUrl` (parser-only — admin requests cannot set it).
 * @export
 * @interface DropStorefrontInput
 */
export interface DropStorefrontInput {
    /**
     * 
     * @type {StorefrontPlatformType}
     * @memberof DropStorefrontInput
     */
    type: StorefrontPlatformType;
    /**
     * 
     * @type {string}
     * @memberof DropStorefrontInput
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof DropStorefrontInput
     */
    username?: string;
    /**
     * 
     * @type {number}
     * @memberof DropStorefrontInput
     */
    detectedAt?: number;
    /**
     * 
     * @type {StorefrontAddedBy}
     * @memberof DropStorefrontInput
     */
    addedBy?: StorefrontAddedBy;
}



/**
 * Check if a given object implements the DropStorefrontInput interface.
 */
export function instanceOfDropStorefrontInput(value: object): value is DropStorefrontInput {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function DropStorefrontInputFromJSON(json: any): DropStorefrontInput {
    return DropStorefrontInputFromJSONTyped(json, false);
}

export function DropStorefrontInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropStorefrontInput {
    if (json == null) {
        return json;
    }
    return {
        
        'type': StorefrontPlatformTypeFromJSON(json['type']),
        'url': json['url'],
        'username': json['username'] == null ? undefined : json['username'],
        'detectedAt': json['detectedAt'] == null ? undefined : json['detectedAt'],
        'addedBy': json['addedBy'] == null ? undefined : StorefrontAddedByFromJSON(json['addedBy']),
    };
}

export function DropStorefrontInputToJSON(json: any): DropStorefrontInput {
    return DropStorefrontInputToJSONTyped(json, false);
}

export function DropStorefrontInputToJSONTyped(value?: DropStorefrontInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': StorefrontPlatformTypeToJSON(value['type']),
        'url': value['url'],
        'username': value['username'],
        'detectedAt': value['detectedAt'],
        'addedBy': StorefrontAddedByToJSON(value['addedBy']),
    };
}

